import {
  invoiceStartGuideSteps,
  invoiceStartGuideTexts,
} from "EinvoiceProject/InvoiceStartGuide/invoiceStartGuideContent";

export const invoiceStartGuideContent = {
  texts: invoiceStartGuideTexts,
  steps: invoiceStartGuideSteps,
  defaultSteps: [
    { id: "1", step: "1", name: "Fill your profile", category: "optional", optional: true },
    { id: "2", step: "2", name: "Add your VAT number", category: "optional", optional: true },
    { id: "3", step: "3", name: "Add your PEPPOL number", category: "optional", optional: true },
    { id: "4", step: "4", name: "Add bank information", category: "optional", optional: true },
  ],
};
